// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import Card from '../../../components/card/Card';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const is_mobile = device.mobile;  
class BatchHealthInfo extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      batch_details:[],
      filtered_data:[],
      headers: [],
      search:'',
      selected_tab:0,
      loading: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getBatchHealth(this.state.venue);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getBatchHealth()  
    })
  }

  getBatchHealth() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7567&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({batch_details:data.data,headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  renderCutsomers(){
   
    var headers = []
    if(this.state.batch_details.length > 0){
      headers = Object.keys(this.state.batch_details[0])
    }
    
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    const groups = []
    console.log("groups",groups)
    console.log(headings)
    return(
      <div>
      <TabHeader className='col-md-12'>
          <Tabs onClick = {()=>this.setState({selected_tab: 0})} style={{color:this.state.selected_tab === 0 && 'white',backgroundColor:this.state.selected_tab === 0 && 'green'}}> Kids Academy Overview </Tabs>
          <Tabs onClick = {()=>this.setState({selected_tab: 1})} style={{color:this.state.selected_tab === 1 && 'white',backgroundColor:this.state.selected_tab === 1 && 'green'}}> Adults Training </Tabs>
          <Tabs onClick = {()=>this.setState({selected_tab: 2})} style={{color:this.state.selected_tab === 2 && 'white',backgroundColor:this.state.selected_tab === 2 && 'green'}}> Adults Playing </Tabs>
        </TabHeader>
        {
          this.state.selected_tab === 0 ? 
            this.state.batch_details.map(item=>(
              <span style={{display:'none'}}> {item[1] != 'Adults'  ? groups.push(item) : ''} </span>
            ))
          : this.state.selected_tab === 1 ?
              this.state.batch_details.map(item=>(
                <span style={{display:'none'}}> { (item[4].includes('Train') || item[4].includes('LearntoSwim'))  &&  groups.push(item)  } </span>
              ))
          : 
            this.state.batch_details.map(item=>(
                <span style={{display:'none'}}> { (item[4].includes('Play') || item[4].includes('SwimAccess')) && groups.push(item) } </span>
              ))
        }

        <table id="table-to" style={{display: 'none'}}>
        <tr> {headings.map((head)=><th>{head.Header}</th>)}</tr>
          {groups.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    <td dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )}
          
      </table>
      <div className='col-md-12 table_container1 table-responsive' style={{marginTop:'2%',marginBottom:'2%'}}>

        <div className="heading" style={{ display: 'flex', justifyContent: 'space-between',marginTop:'1%'}}>
          <span style={{fontWeight: 'bold', fontSize: '18px'}}>Batch Health</span>
          <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-primary"
                        table="table-to"
                        filename="Batch Health"
                        sheet="Batch Health"
                        buttonText="Download as XLS"/>
        </div> 
        { this.state.batch_details.length > 0 ?
          <ReactTable  
                      data={groups}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.batch_details.length > 100}
                      showPaginationTop = {this.state.batch_details.length > 100}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
            {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
            }
          </ReactTable>
          :

          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
          :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      </div>
      )
  }

  
  render() {

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    
    console.log('props data',this.props)
    console.log('customer_data',this.state.customer_data)
    return(
      <div >
        <div className='col-md-12'>
            {this.renderCutsomers()}
        </div>  

      </div>
    );
  }
}

export default BatchHealthInfo;


const TabHeader = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 20px;
  margin-top:10px;
`


const Tabs = styled.div`
  color: black ;
  background-color:beige;
  transition:0.5s;
  border: 2px solid green;
  padding: 7px;
  font-weight: 700;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
`






// WEBPACK FOOTER //
// ./src/app/views/centerportal/batchHealthInfo/BatchHealthInfo.js